export const BRAND = {
  name: "한옥담",
  nameEn: "HANOKDAM",
  slogan: "계절의 맛을 정성으로 담다",
  intro: "전통 한식의 기본을 지키며 현대적으로 재해석하는 프리미엄 다이닝입니다. 제철 식재료와 장인의 손맛으로 완성하는 코스 요리를 경험해 보세요.",
  address: "서울특별시 종로구 북촌로 82",
  phone: "02-744-3300",
  hours: "화-일 12:00 - 22:00 (Lunch 12-15 / Dinner 18-22) · 월요일 휴무",
};

export const NAV = [
  { id: "philosophy", label: "철학" },
  { id: "menu", label: "코스" },
  { id: "chef", label: "셰프" },
  { id: "private", label: "프라이빗" },
  { id: "reserve", label: "예약" },
];

export const COURSES = [
  {
    name: "담 Course",
    price: "85,000원",
    desc: "한옥담의 기본 코스. 제철 전채와 메인, 디저트 7품",
    items: ["제철 나물 3종", "생선 구이", "한우 구이", "솥밥", "디저트"],
  },
  {
    name: "정 Course",
    price: "120,000원",
    featured: true,
    desc: "시그니처 코스. 장인 발효 소스와 프리미엄 식재료 9품",
    items: ["셰프 특선 전채", "해산물", "한우 안심", "계절 국", "한과 디저트"],
  },
  {
    name: "온 Course",
    price: "165,000원",
    desc: "최상급 식재료로 구성한 스페셜 11품 코스",
    items: ["프리미엄 전채", "랍스터", "한우 등심", "버섯 요리", "페어링 디저트"],
  },
];

export const CHEF = {
  name: "이한결 셰프",
  title: "Executive Chef",
  bio: "20년 한식 경력. 전 통영 미슐랭 레스토랑 수석 셰프 출신으로 제철 식재료의 본질을 살리는 요리를 추구합니다.",
};

export const PRIVATE = [
  { name: "복실 룸", capacity: "4-6인", desc: "북촌 뷰 프라이빗 룸" },
  { name: "한옥 룸", capacity: "8-10인", desc: "단체 모임·상견례 전용" },
];
